import { IconProps } from "@/src/sb/business-layer/types"

const ArrowRight = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 17 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.57531 13.2426L9.04498 12.7123L12.3834 9.37387H3.58523L3.58523 8.6261L12.3834 8.6261L9.04498 5.28767L9.57531 4.75734L13.8179 8.99998L9.57531 13.2426Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowRight
